module.exports = __webpack_public_path__ + "img/Peche_en_atlantique_nord_est.69ef1f01.png";